import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LAUNCH_ERROR} from "../../actions/auth";
import * as spActions from '../../actions/sp';
import * as messages from '../../shared/messages';
import './index.scss';

const LAUNCH_ERROR_MESSAGES = {
  [LAUNCH_ERROR.INVALID_CONTEXT]: messages.LAUNCH_ERROR_INVALID_CONTEXT,
  [LAUNCH_ERROR.SIGN_IN_FAILED]: messages.LAUNCH_ERROR_SIGN_IN_FAILED,
  [LAUNCH_ERROR.CONFIGURATION]: messages.LAUNCH_ERROR_CONFIGURATION,
  [LAUNCH_ERROR.SESSION_EXPIRED]: messages.LAUNCH_ERROR_SESSION_EXPIRED,
  [LAUNCH_ERROR.GENERIC]: messages.GENERIC_ERROR,
};

export class LaunchError extends Component {
  render() {
    return (
        <div className="launch-error-container">
          <div className="launch-error-message" role="alert">
            {LAUNCH_ERROR_MESSAGES[this.props.launchError]}
          </div>
          {this.props.applianceUrl ? (
              <div className="launch-error-actions">
                <button
                    id="cancelLaunchButton"
                    type="button"
                    className="btn btn-md cancel-save-button"
                    onClick={this.props.cancelAddApp}
                >
                  {messages.CANCEL}
                </button>
              </div>
          ) : null}
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    launchError: state.auth.launchError,
    applianceUrl: state.auth.applianceUrl,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LaunchError);
